import React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

export const BrandContent: React.FunctionComponent<any> = ({ children }) => {
  return (
    <Container component="main" maxWidth="sm" sx={{ flex: 1, display: "flex", alignItems: "center" }}>
      <CssBaseline />
      <Box
        sx={{
          width: "100%",
          marginY: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#FFFFFF",
          border: "1px solid #E2E8F0",
          borderRadius: "14px",
          boxShadow: "0 1px 2px rgba(15,23,42,0.06), 0 8px 24px rgba(15,23,42,0.07)",
          p: 6,
        }}
      >
        {children}
      </Box>
    </Container>
  );
};

export default BrandContent;
